//import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap/dist/css/bootstrap-theme.css';
import 'babel-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Employees from './Employees';
import PasswordReset from './PasswordReset'
import OrganizationInviteUsersBS3 from './OrganizationInviteUsersBS3'
import UpgradePersonalAccount from './manageOrg/UpgradePersonalAccount'
import EventAttendanceTracking from './EventAttendanceTracking'
import CreateOrganizationAccount from './firstnetSubscriberOnboarding/CreateOrganizationAccount';
import ConvertToOrganizationAccount from './firstnetSubscriberOnboarding/ConvertToOrganizationAccount';
import UpgradePlaygroundToCorporateAccount from './firstnetSubscriberOnboarding/UpgradePlaygroundToCorporateAccount';
import RegisterUserWithJoinCode from './registration/RegisterUserWithJoinCode';
import MmaRouter from './manageMyAccount/MmaRouter';
import AppCatalog from './manageMyAccount/AppCatalog';
import SearchContainer from './firstnet/search/organization/containers/SearchContainer';
import NetPromoterScorePointsTracking from './firstnet/NetPromoterScore/NetPromoterScorePointsTracking';
import NpsStatus from './manageMyAccount/NpsStatus';

import RegistrationRouter from './registration/RegistrationRouter'


const reactEmployeesElement = document.getElementById('reactEmployees');
if(reactEmployeesElement){
  ReactDOM.render(<Employees />, reactEmployeesElement);
}

const reactPasswordResetElement = document.getElementById('reactPasswordReset');
if(reactPasswordResetElement){
  ReactDOM.render(<PasswordReset />, reactPasswordResetElement);
}

const reactOrganizationInviteUsersElement = document.getElementById('reactOrganizationInviteUsers');
if(reactOrganizationInviteUsersElement){
  ReactDOM.render(<OrganizationInviteUsersBS3 />, reactOrganizationInviteUsersElement);
}


const reactUpgradePersonalAccountElement = document.getElementById('reactUpgradePersonalAccount');
if(reactUpgradePersonalAccountElement){
  ReactDOM.render(<UpgradePersonalAccount />, reactUpgradePersonalAccountElement);
}

const reactEventAttendanceTrackingElement = document.getElementById('reactEventAttendanceTracking');
if(reactEventAttendanceTrackingElement){
  ReactDOM.render(<EventAttendanceTracking/>, reactEventAttendanceTrackingElement);
}

const reactRegistrationRouterElement = document.getElementById('reactRegistrationRouter');
if(reactRegistrationRouterElement){
  ReactDOM.render(<RegistrationRouter/>, reactRegistrationRouterElement);
}

const reactFirstNetSubscribersCreateCorporateAccountElement = document.getElementById('reactFirstNetSubscribersCreateCorporateAccount');
if(reactFirstNetSubscribersCreateCorporateAccountElement){
  ReactDOM.render(<CreateOrganizationAccount/>, reactFirstNetSubscribersCreateCorporateAccountElement);
}

const reactFirstNetSubscribersConvertToCorporateAccountElement = document.getElementById('reactFirstNetSubscribersConvertToCorporateAccount');
if(reactFirstNetSubscribersConvertToCorporateAccountElement){
  ReactDOM.render(<ConvertToOrganizationAccount/>, reactFirstNetSubscribersConvertToCorporateAccountElement);
}

const reactFirstNetSubscribersUpgradePGToCorporateAccountElement = document.getElementById('reactFirstNetSubscribersUpgradePGToCorporateAccount');
if(reactFirstNetSubscribersUpgradePGToCorporateAccountElement){
  ReactDOM.render(<UpgradePlaygroundToCorporateAccount/>, reactFirstNetSubscribersUpgradePGToCorporateAccountElement);
}

const reactFirstNetRegisterUserWithJoinCodeElement = document.getElementById('reactFirstNetRegisterUserWithJoinCode');
if(reactFirstNetRegisterUserWithJoinCodeElement){
  ReactDOM.render(<RegisterUserWithJoinCode/>, reactFirstNetRegisterUserWithJoinCodeElement);
}

const reactmmaRouterElement = document.getElementById('reactmmaRouter');
if(reactmmaRouterElement){
  ReactDOM.render(<MmaRouter/>, reactmmaRouterElement);
}

const reactAppCatalogElement = document.getElementById('reactAppCatalog');
if(reactAppCatalogElement){
  ReactDOM.render(<AppCatalog/>, reactAppCatalogElement);
}

const reactFirstNetOrgSearchElement = document.getElementById('reactFirstNetOrgSearch');
if(reactFirstNetOrgSearchElement){
  ReactDOM.render(<SearchContainer/>, reactFirstNetOrgSearchElement);
}

const reactNetPromoterScorePointsTrackingElement = document.getElementById('reactNetPromoterScorePointsTracking');
if(reactNetPromoterScorePointsTrackingElement){
  ReactDOM.render(<NetPromoterScorePointsTracking/>, reactNetPromoterScorePointsTrackingElement);
}

const npsStatusElement = document.getElementById('npsStatus');
if(npsStatusElement){
  ReactDOM.render(<NpsStatus />, npsStatusElement);
}
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js